import $ from "jquery";
import "./jquery-popup";
import { postback } from "./fs-form";

var isSafari = navigator.userAgent.indexOf("Safari/") >= 0 && navigator.userAgent.indexOf("Chrome/") < 0;

function initGrids(ctx, doNotProcessHash, scrollOptions) {
	function safariFixCallback(e) {
		// HACK: Safari 10.1 (+ iOS): caption jumps below the table after clicking Customize
		// This is kludge
		var c = $(e).closest("caption").hide();
		setTimeout(function () { c.show(); }, 0);
	}

	var grids = $("table.fs-grid", ctx);
	// table header scrolling
	grids.tHeadScroll(scrollOptions);
	// table customization
	grids.find(">caption .fs-customize").each(function () {
		var e = $(this);
		e.find(">div.ui-popup").popup(e.find(">button"), {}, isSafari ? safariFixCallback : null).on("click", function (e) {
			if ($(e.target).closest("label").length)
				e.stopPropagation();
		}).find(">ul.ui-menu").menu();
		if (isSafari) {
			e.find(">button").on("click", function () {
				safariFixCallback(this);
			});
		}
	});
	grids.find(">thead>tr.fs-filterrow").each(function () {
		var action = $(this).attr("fs-action");
		$("INPUT,SELECT", this).on("change", function () { postback($(this), action, false); });
		$("input", this).on("keydown", function (e) {
			if (e.key == "Enter") {
				e.stopPropagation();
				postback($(this), action, false);
			}
		});
	});
	grids.filter(".fs-quicksearch").each(function () {
		var g = $(this);
		g.find(">thead>tr>td")
			.append(
				$("<span/>", { "class": "fs-quicksearch" })
					.append($("<input placeholder=\"Quick Search...\">")
						.quicksearch({ selector: g })));
	});

	var hash = location.hash;
	function ensureVisible() {
		$.ensureVisible(hash);
	}

	if (!doNotProcessHash && hash && hash.length > 1) {
		if (ctx != null)
			ensureVisible();
		else
			$(window).on("load", function () {
				setTimeout(ensureVisible, 200);
			});
	}
}

export { initGrids };
